export default __webpack_public_path__ + "static/media/two-tips.f55fe66a.svg";